import { Box } from "@chakra-ui/react";
import {
  TabMenuOptions,
  TabsMenuOptionsRoutes,
} from "features/tenants/data/TabsMenuOptions";
import { showError } from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import { useLocation, useParams, useRouteMatch } from "react-router";

import MenuDetalhes from "components/Menu/MenuDetalhes";
import TenantHeader from "./components/TenantHeader";
import TenantTabs from "./components/TenantTabs";
import history from "infra/helpers/history";
import { useBreadcrumb } from "features/breadcrumbs";
import useGetTenant from "features/tenants/hooks/useGetTenant";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import { useLoading } from "components/GlobalLoading";
import { useCurrentTenant } from "features/auth/tenant.store";
import Container from "components/Container";

function DetalhesCondominio() {
  const route = useRouteMatch();

  const { tenant: currentTenant } = useCurrentTenant();

  let { id } = useParams() as { id?: string };

  const routePath = route.path;

  const isCurrentCondominio = routePath.includes("meu-condominio");
  const isCurrentEmpresa = routePath.includes("empresa");
  const shouldUseCurrentTenant = isCurrentCondominio || isCurrentEmpresa;

  if (shouldUseCurrentTenant) {
    id = currentTenant.id;
  }

  const options = TabMenuOptions.filter((item) => {
    if (
      item.route === TabsMenuOptionsRoutes.UsuariosLegais &&
      shouldUseCurrentTenant
    ) {
      return false;
    }

    return true;
  });

  const createDisabledOptions = options
    .filter((option) => option.route !== options[0].route)
    .map((option) => option.route); // .filter(route => route !== );

  const getBreadcrumbText = () => {
    if (isCurrentCondominio) {
      return "Meu Condomínio";
    } else if (isCurrentEmpresa) {
      return "Minha Empresa";
    }
    return "";
  };

  useBreadcrumb(
    !shouldUseCurrentTenant
      ? [
          { name: "Condomínios", url: "/condominio" },
          {
            name: `${id ? "Editar" : "Criar"} Condomínio`,
            url: "/condominio/criar",
          },
        ]
      : [
          {
            name: getBreadcrumbText(),
          },
        ]
  );

  const opcaoParam =
    new URLSearchParams(useLocation().search).get("opcao") ||
    TabsMenuOptionsRoutes.Dados;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  useEffect(() => {
    setSelectedMenuOption(opcaoParam);
  }, [opcaoParam]);

  const { data: tenant, isLoading, isError } = useGetTenant(id);

  useLoading(isLoading);

  const enableEditOptions = !!id;

  useEffect(() => {
    if (isError) {
      showError().then(() => {
        if (!shouldUseCurrentTenant) {
          history.push("/condominio");
        }
      });
    }
  }, [shouldUseCurrentTenant, isError]);

  if (isError) {
    return null;
  }

  return (
    <Container>
      <TenantHeader tenant={tenant} />
      <Box
        mt={8}
        pb={32}
        gridGap={8}
        display="flex"
        flexDir={["column", "column", "row"]}
      >
        <Box mb={4}>
          <MenuDetalhes
            options={options}
            disabledOptions={enableEditOptions ? [] : createDisabledOptions}
            selectedOption={selectedMenuOption ?? TabsMenuOptionsRoutes.Dados}
            onChangeOption={(tab) => {
              setSelectedMenuOption(tab);
              if (id) {
                if (shouldUseCurrentTenant) {
                  history.push(`${routePath}?opcao=${tab}`);
                } else {
                  history.push(`/condominio/${id}?opcao=${tab}`);
                }
              } else {
                history.push(`/condominio/criar?opcao=${tab}`);
              }
            }}
          />
        </Box>
        <Box flex={1}>
          <TenantTabs
            tenant={
              {
                tipoTenantId: TipoTenantEnum.Condominio,
                ...tenant,
              } as any
            }
            id={id}
            tabActive={
              (selectedMenuOption as TabsMenuOptionsRoutes) ??
              TabsMenuOptionsRoutes.Dados
            }
            onSubmitSuccess={(result: any) => {
              if (!id) {
                setSelectedMenuOption(TabsMenuOptionsRoutes.Unidades);
                history.push(
                  `/condominio/${result}?opcao=${TabsMenuOptionsRoutes.Unidades}`
                );
              }
              window.location.reload();
            }}
          />
        </Box>
      </Box>
    </Container>
  );
}

export default DetalhesCondominio;
